import { Clerk } from '@clerk/clerk-js'
import { defineNuxtPlugin } from 'nuxt/app'
import type { App } from 'vue'
import { useRuntimeConfig } from '#imports'

export default defineNuxtPlugin({
  name: 'clerk',
  async setup(nuxt) {
    const runtimeConfig = useRuntimeConfig()
    const clerk = new Clerk(runtimeConfig.public.clerkPublishableKey)
    await clerk.load({
      telemetry: false,
    })

    // Create a Vue plugin that uses the Clerk instance
    const clerkPlugin = {
      install(app: App) {
        app.config.globalProperties.$clerk = clerk
      },
    }

    nuxt.vueApp.use(clerkPlugin)
    return {
      provide: {
        clerk,
        signIn: clerk.client?.signIn,
        signUp: clerk.client?.signUp,
      },
    }
  },
})
